import { Box, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../utils/colors';

const StyledBox = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: spaceCadet[100],

  '& .dual-channel-auth-loading': {
    minHeight: '100vh',
  },

  '& .dual-channel-sign-in': {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '& .login-card': {
    width: '100%',
    maxWidth: 768,
    backgroundColor: 'white',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: 4,
  },

  '& .login-actions': {
    padding: theme.spacing(4),
  },

  '& .trouble-box': {
    padding: theme.spacing(1, 2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '&.expanded': {
      backgroundColor: theme.palette.grey[100],
    },
  },

  '& .trouble-toggle': {
    padding: 0,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },

  '& .trouble-content': {
    padding: theme.spacing(2),
    borderRadius: 4,
    textAlign: 'center',
  },

  '& .trouble-inner': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  '& .clear-storage-button': {
    color: ultraMarine[500],
    borderColor: ultraMarine[500],
    textTransform: 'none',
    backgroundColor: 'white',
  },
}));

export default StyledBox;
